import { getUserInitials } from "@/app/utils/get-user-initials";
import { Card } from "@/components/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Guest, GuestType, PublicEvent } from "@classview/shared-types";

import { ViewParticipantsModal } from "./view-participants-model";

type AttendeesCardProps = {
  attendees: Guest[];
  event: PublicEvent;
};

export function AttendeesCard({ attendees, event }: AttendeesCardProps) {
  if (attendees.length === 0) {
    return null;
  }

  const first10Attendees = attendees.slice(0, 10);
  return (
    <Card>
      <Card.Content className="flex flex-col gap-4">
        <span className="text-lg font-medium text-foreground">Attendees</span>
        <p className="text-sm text-muted-foreground">
          {attendees.length} {attendees.length === 1 ? "person" : "people"} have
          registered for this event
        </p>
        <div className="flex">
          {first10Attendees?.map((attendee) => (
            <div className="w-6" key={attendee.email}>
              <Avatar key={attendee.email} className="border-2">
                {attendee.type === GuestType.User && attendee.avatarURL && (
                  <AvatarImage src={attendee.avatarURL} />
                )}
                <AvatarFallback className="select-none bg-border capitalize text-muted">
                  {getUserInitials(
                    attendee?.firstName ?? "",
                    attendee?.lastName ?? "",
                  )}
                </AvatarFallback>
              </Avatar>
            </div>
          ))}
          {attendees.length > 10 && (
            <AvatarFallback className="select-none bg-border capitalize text-muted">
              +{attendees.length - 10}
            </AvatarFallback>
          )}
        </div>
        <ViewParticipantsModal guests={attendees} event={event} />
      </Card.Content>
    </Card>
  );
}
